<style lang="scss">
  @import "./trace";
</style>

<script>
import { CONSTANT } from '../../../utils/constant.js'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'

export default {

  components: {
    VueJsonPretty
  },

  data () {
    return {
      traceLogs: [],
      txnLogs: [0],
      request: [],
      response: [],
      time: [],
      CONSTANT: CONSTANT
    }
  },

  created () {
    this.traceLogs = JSON.parse(localStorage.getItem('traceLog')) || []
    this.traceLogs = this.traceLogs.slice().reverse()
  },

  methods: {

    clear () {
      this.traceLogs = null
      localStorage.setItem('traceLog', null)
    },

    gotoConfigPage () {
      this.$emit('closeTrace')
      this.$router.push('/configuration/checkout').catch(err => { console.error(err) })
    },

    /* eslint-disable */
    downloadApiLogs () {
      let trace = document.getElementById('downloadApiLogs').innerHTML
      let style = '<style type="text/css">pre{display:block;font-size:13px;line-height:1.42857143}h5{font-size:14px; margin-left:20px;}h4{font-size:100%;word-break:break-word;margin-bottom:-10px;font-weight:700;position:relative;margin-top:15px}.collapsible{border-radius:5px;box-shadow:0 0 3px -1px black;overflow:hidden;margin:20px;background-color:white}.collapsible .top{padding:5px;position:relative}.collapsible .bottom{border-top:1px solid lightgray;display: block!important}.collapsible pre{border:none;border-radius:0;padding:10px;margin:0;overflow-x:auto;word-break:normal;word-wrap:normal;position:static;}<\/style>'
      let script = '<script type="text/javascript">$(document).ready(function(){var t;$("pre");$("pre").each(function(e){(t=$(this).text(),htmlFirstChar=t.charAt(0),"{"==htmlFirstChar&&$(this).text(vkbeautify.json(t,4)),"["==htmlFirstChar&&$(this).text(vkbeautify.json(t,4)))})});<\/script>'
      let htmlWrapper = '<!DOCTYPE html><html><head><meta charset="UTF-8"><script src="https://code.jquery.com/jquery-3.2.1.slim.min.js" ><\/script><script src="https://storage.googleapis.com/google-code-archive-downloads/v2/code.google.com/vkbeautify/vkbeautify.0.99.00.beta.js" ><\/script>' + style + '<title>API Log</title></head>'
      htmlWrapper += '<body>' + trace + script
      htmlWrapper += '</body></html>'
      if (window.navigator.msSaveBlob) { // IE
        let blob = new Blob([htmlWrapper], { type: 'data:text/html;charset=utf-8;' })
        window.navigator.msSaveOrOpenBlob(blob, 'API-log.html')
      } else {
        let downloadLink = document.createElement('a')
        downloadLink.className = 'download-link'
        downloadLink.href = 'data:text/html,' + encodeURIComponent(htmlWrapper)
        downloadLink.download = 'API-log.html'
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(document.getElementsByClassName('download-link')[0])
      }
    },
    /* eslint-enable */

    txnLogToggle (txnIndex) {
      if (this.txnLogs.includes(txnIndex)) {
        this.txnLogs.splice(this.txnLogs.indexOf(txnIndex), 1)
      } else {
        this.txnLogs.push(txnIndex)
      }
    },

    txnApiLogToggle (txnIndex, apiLogIndex, apiLogName) {
      let apiLogs = this[apiLogName][txnIndex] || []
      if (apiLogs.length <= 0) {
        apiLogs.push(apiLogIndex)
      } else if (apiLogs.includes(apiLogIndex)) {
        apiLogs.splice(apiLogs.indexOf(apiLogIndex), 1)
      } else {
        apiLogs.push(apiLogIndex)
      }
      this[apiLogName][txnIndex] = Array.from(apiLogs)
      this[apiLogName] = Array.from(this[apiLogName])
    }

  }
}
</script>

<template>
  <div id="traceLog">
    <div class="control col-xs-12 col-sm-12 col-md-9 col-lg-9">
      <div class="pull-left h-left">
        <div class="src-api-trace-logo">
          <i class="fa fa-code mt-2" />
        </div>
        <label class="src-config-content-header">{{ $t ('label.allLogs') }}</label>
      </div>
      <div class="pull-right h-right">
        <button
          v-if="!!traceLogs && (traceLogs).length > 0"
          class="src-api-download-btn"
          @click="downloadApiLogs"
        />
        <button
          id="trace-clear"
          class="clearTrace btn border-dark text-dark"
          @click="clear"
        >
          {{ $t ('label.clearAll') }}
        </button>
        <div
          class="src-show-config-btn rotate"
          @click="gotoConfigPage()"
        >
          <i class="fa fa-cogs" />
        </div>
        <div
          class="src-api-trace-close-btn"
          @click="$emit('closeTrace')"
        />
      </div>
    </div>
    <div class="content col-xs-12 col-sm-12 col-md-9 col-lg-9 mt-3">
      <div
        id="traceApiLogs"
        class="request"
      >
        <div
          v-for="(txn, txnIndex) in traceLogs"
          :key="txnIndex"
        >
          <div class="collapsible">
            <div
              class="top"
              @click="txnLogToggle(txnIndex)"
            >
              <span v-if="txnIndex === 0">Most Recent</span>
              Transaction
              <span style="margin-left: 20px;">
                {{ new Date(txn.initiationTime).toLocaleDateString() }}
                {{ new Date(txn.initiationTime).toLocaleTimeString() }}
              </span>
            </div>
            <div
              v-show="txnLogs.includes(txnIndex)"
              class="bottom txn-bottom"
            >
              <div
                v-for="(traceLog, traceLogIndex ) in txn.data"
                :key="traceLogIndex"
              >
                <h5><i>{{ traceLog.methodName }}</i></h5>
                <div class="collapsible">
                  <div
                    class="top"
                    @click="txnApiLogToggle(txnIndex, traceLogIndex,'request')"
                  >
                    {{ $t ('label.request') }}
                  </div>
                  <div
                    v-show="(request[txnIndex] || []).includes(traceLogIndex)"
                    class="bottom"
                  >
                    <vue-json-pretty
                      :deep="1"
                      :data="traceLog.request"/>
                  </div>
                </div>
                <div class="collapsible">
                  <div
                    class="top"
                    @click="txnApiLogToggle(txnIndex, traceLogIndex,'response')"
                  >
                    <div>{{ $t ('label.response') }}</div>
                  </div>
                  <div
                    v-show="(response[txnIndex] || []).includes(traceLogIndex)"
                    class="bottom"
                  >
                    <vue-json-pretty
                      :deep="1"
                      :data="traceLog.response"/>
                  </div>
                </div>
                <div class="collapsible">
                  <div
                    class="top"
                    @click="txnApiLogToggle(txnIndex, traceLogIndex, 'time')"
                  >
                    <div>{{ $t ('label.timeTaken') }}</div>
                  </div>
                  <div
                    v-show="(time[txnIndex] || []).includes(traceLogIndex)"
                    class="bottom"
                  >
                    <div class="text-uppercase">
                      <vue-json-pretty
                        :deep="2"
                        :data="traceLog.timeTaken"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr
            v-if="txnIndex === 0"
            class="dashed-line">
        </div>
      </div>
    </div>
    <div
      id="downloadApiLogs"
      style="display: none;"
    >
      <div
        v-for="(txn, txnIndex) in traceLogs"
        :key="txnIndex"
      >
        <div class="collapsible">
          <div class="top">Transaction</div>
          <div class="bottom">
            <div
              v-for="(traceLog, traceLogIndex ) in txn.data"
              :key="traceLogIndex"
            >
              <h5><i>{{ traceLog.methodName }}</i></h5>
              <div class="collapsible">
                <div class="top">
                  {{ $t ('label.request') }}
                </div>
                <div class="bottom">
                  <pre>{{ traceLog.request }}</pre>
                </div>
              </div>
              <div class="collapsible">
                <div class="top">
                  {{ $t ('label.response') }}
                </div>
                <div class="bottom">
                  <pre>{{ traceLog.response }}</pre>
                </div>
              </div>
              <div class="collapsible">
                <div class="top">
                  {{ $t ('label.timeTaken') }}
                </div>
                <div class="bottom">
                  <pre class="text-uppercase">{{ traceLog.timeTaken }}</pre>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
